<button class="goback mb-3" routerLink="/locations">
    <i class="bi bi-arrow-left"></i> Back to Locations List
</button>

<div class="content-info">
    <div class="content-title mb-4 p-4">
        <h3 class="title mb-0">{{ isEditMode ? 'Edit' : 'Create' }} Location</h3>
    </div>

    <div class="card overflow-hidden">
        <div class="card-body p-4">
            <form [formGroup]="locationForm" (ngSubmit)="onSubmit()">
                <div class="row g-4">
                    <!-- Location Name -->
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="name" class="form-label">Location Name <span
                                    class="text-danger ms-1">*</span></label>
                            <input type="text" id="name" formControlName="name" class="form-control"
                                [class.is-invalid]="locationForm.get('name')?.touched && locationForm.get('name')?.invalid"
                                placeholder="e.g. Zenflow Warehouse" />
                            <div class="invalid-feedback">
                                Name is required (min 3 characters).
                            </div>
                        </div>
                    </div>

                    <!-- Location Type -->
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="type" class="form-label">Location Type <span
                                    class="text-danger ms-1">*</span></label>
                            <select id="type" formControlName="type" class="form-select"
                                [class.is-invalid]="locationForm.get('type')?.touched && locationForm.get('type')?.invalid">
                                <option value="" disabled selected>Select Type</option>
                                @for (type of locationTypes; track type) {
                                <option [value]="type">{{ typeLabels[type] || type }}</option>
                                }
                            </select>
                            <div class="invalid-feedback">Type is required.</div>
                        </div>
                    </div>

                    <!-- Parent Location -->
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="parentLocationId" class="form-label">Parent Location</label>
                            <select id="parentLocationId" formControlName="parentLocationId" class="form-select">
                                <option [value]="null">No Parent (Top Level)</option>
                                @for (loc of parentLocations; track loc.id) {
                                <option [value]="loc.id">{{ loc.name }} ({{ loc.type }})</option>
                                }
                            </select>
                            <div class="form-text mt-2 small text-muted">Optional: Assign a parent for hierarchical
                                locations.</div>
                        </div>
                    </div>

                    <!-- Active Status -->
                    <div class="col-md-6">
                        <div class="form-check form-switch mt-md-4 py-2">
                            <input class="form-check-input" type="checkbox" id="isActive" formControlName="isActive">
                            <label class="form-check-label ms-2" for="isActive">Active Status</label>
                            <div class="form-text small text-muted mt-2 d-block">
                                Switch off to temporarily disable this location.
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Action Buttons -->
                <div class="mt-4 pt-3 border-top d-flex gap-2">
                    <button type="submit" class="btn btnprimary px-5 py-3" [disabled]="isLoading">
                        @if (isLoading) {
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        }
                        {{ isEditMode ? 'Update Location' : 'Create Location' }}
                    </button>
                    <button type="button" class="btn btn-outline-secondary px-5 py-3" routerLink="/locations"
                        [disabled]="isLoading">
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>